<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Destination/Detail</h1>
      </div>
      <div
        class="mr-10"
        v-if="this.$route.params.id === this.deployedDestinationId"
      >
        <span class="text-2xl text-dark font-bold">
          Selected
        </span>
      </div>
      <div class="mr-10" v-else>
        <button
          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-2xl bg-app-default hover:bg-app-light text-white font-bold"
          type="button"
          @click="updateDeployedDestination(this.$route.params.id)"
        >
          Select
        </button>
      </div>
    </div>

    <!-- <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Carousel Image (1200 px X 500 px)
            </div>
          </div>
          <div class="flex">
            <img
              class="w-full lg:w-9/12 mr-3 h-44 lg:h-80"
              :src="dataDestination.destination_carousel"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div> -->

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Image (1020 px X 1020 px)</div>
          </div>
          <div class="flex">
            <img
              
              :key="dest"
              class="w-56 h-56 mr-3"
              :src="dataDestination?.destination_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Destination Info</div>
          </div>
          <div class="font-semibold">Name</div>
          <div v-if="dataDestination.destination_name !== ''" class="ml-5">
            {{ dataDestination.destination_name }}
          </div>
          <div class="font-semibold">Description</div>
          <div
            v-if="dataDestination.destination_description !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_description }}
          </div>
          <div class="font-semibold">Contact</div>
          <div v-if="dataDestination.destination_contact !== ''" class="ml-5">
            {{ dataDestination.destination_contact }}
          </div>
          <div class="font-semibold">Operation Day</div>
          <div
            v-if="dataDestination.destination_operation_day !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_operation_day }}
          </div>
          <div class="font-semibold">Time Open</div>
          <div v-if="dataDestination.destination_open_time !== ''" class="ml-5">
            {{ dataDestination.destination_open_time }}
          </div>
          <div class="font-semibold">Time Closed</div>
          <div
            v-if="dataDestination.destination_closed_time !== ''"
            class="ml-5"
          >
            {{ dataDestination.destination_closed_time }}
          </div>
          <!-- <div class="font-semibold">Status</div>
          <div v-if="dataDestination.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div> -->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import API from "../../api";
import BackButton from "../../components/BackButton.vue";
export default {
  name: "ContentDetail",
  components: {
    BackButton,
  },
  data() {
    return {
      dataDestination: {},
      deployedDestinationId: null,
    };
  },
  methods: {
    detailDestination: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        this.dataDestination = respon.data;
      } catch (err) {
        this._error("internal server error");
        this.$router.go(-1);
        return;
      }
    },
    updateDeployedDestination: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/displayed_destination/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        this.deployedDestinationId = this.$route.params.id;
      } catch (err) {
        this._error("Internal server error");
        this.$router.go(-1);
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailDestination();
    this.deployedDestinationId = this.$route.query.deployedDestinationId;
  },
};
</script>
